export default function isInTeacherWebsite() {
  return window.location.href.includes("/teacher");
}
